(function () {
  const refDescription = document.querySelector(".ref-description");
  const formContainer = document.querySelector(".ref-form");
   const allSocialMediaLinksImages = document.querySelectorAll('.social_media__links a img');
  const form = formContainer.querySelector("form");
  form?.addEventListener("submit", function (e) {
    e.preventDefault();
    const email = form?.querySelector('input[type="email"]').value;
    const name = form?.querySelector('input[type="text"]').value;
    const btn = form?.querySelector("button");
    const btnText = btn?.querySelector("p");

    btn.disabled = true;
    btnText.innerText = "Loading...";

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email,
      firstName: name,
      campaignId: 95070,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("https://api.referralcorner.com/signup/join-block", requestOptions)
      .then((res) => {
        if (!res.ok) {
          btnText.innerText = "Error happened";
          setTimeout(() => {
            btnText.innerText = "Get invite link";
          }, 1000);
          throw new Error("Network response was not ok");
        }

        return res.json();
      })
      .then((result) => {
        console.log(result);
       
        formContainer.classList.add("hidden");
        refDescription.classList.add("hidden");
        document.querySelector(".ref-form-results").classList.remove("hidden");
        document.querySelector('.ref-form-results input[name="url"]').value =
          result?.content?.referralData?.url; 
        Object.entries(result.content.referralData).forEach(([key, value]) => {
    allSocialMediaLinksImages.forEach((img) => {
        if (key===img.alt.toLowerCase()) { 
            img.parentElement.href=value
        }
    });
});

        console.error("Error:", result.message);
      })
      .catch((error) => console.error(error));
  });
})();
